import axios from "axios";
import { initializeApp, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { env } from "configs/EnvironmentConfig";

/**
 * Resolve Django REST root (/api) from vendor base (/api/vendor).
 */
export function getOcApiRoot() {
  return String(env.API_ENDPOINT_URL || "").replace(/\/?vendor\/?$/i, "");
}

export async function getVendorFirebaseBootstrapPayload(storeId) {
  const root = getOcApiRoot();
  const { data } = await axios.get(`${root}/oc/firebase-web/`, {
    headers: { "Store-ID": String(storeId) },
    timeout: 15000,
  });
  const payload = data?.data ?? data;
  if (!payload?.config?.apiKey) {
    throw new Error(
      "Firebase Web config is not configured for this store in Settings.",
    );
  }
  if (!payload?.google_enabled) {
    throw new Error(
      "Google Sign-In is disabled for this store.",
    );
  }
  return payload;
}

export async function getVendorFirebaseAppForStore(storeId) {
  const payload = await getVendorFirebaseBootstrapPayload(storeId);
  const cfg = payload.config;
  const appName = `vendor_${storeId}_${cfg.projectId}`;
  let app;
  try {
    app = getApp(appName);
  } catch {
    app = initializeApp(cfg, appName);
  }
  return { app, payload };
}

/**
 * Bootstrap Firebase Web SDK for vendor-panel Google login (before JWT exists).
 */
export async function initVendorFirebaseForStore(storeId) {
  const { app } = await getVendorFirebaseAppForStore(storeId);
  return {
    auth: getAuth(app),
    googleAuthProvider: new GoogleAuthProvider(),
  };
}
